import React, { useEffect, useState } from "react";
import { fetchUserLogs, markLogsAsRead } from "../../../http/userLogAPI";
import { useContext } from "react";
import { Context } from "../../../index";
import {Modal, Button, ListGroup, Badge, Spinner, Table} from "react-bootstrap";

const UserLogsModal = ({ show, handleClose }) => {
    const { user } = useContext(Context);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [markingRead, setMarkingRead] = useState(false);

    // Загружаем логи пользователя при открытии модального окна
    useEffect(() => {
        if (show) {
            fetchUserLogs(user.user.id)
                .then(data => setLogs(data))
                .finally(() => setLoading(false));
        }
    }, [show, user.user.id]);

    // Отметить все логи как прочитанные
    const handleMarkAsRead = async () => {
        setMarkingRead(true);
        await markLogsAsRead(user.user.id);
        setLogs(logs.map(log => ({ ...log, is_read: true }))); // Обновляем состояние
        setMarkingRead(false);

    };

    const handleMarkAsReadAndClose = async () => {
        setMarkingRead(true);
        await markLogsAsRead(user.user.id);
        setLogs(logs.map(log => ({ ...log, is_read: true }))); // Обновляем состояние
        setMarkingRead(false);
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose} size="xl" centered scrollable >
            <Modal.Header closeButton className="position-relative">
                <Modal.Title className="text-muted">Log's and Balance:</Modal.Title>

                <div className="position-absolute top-50 start-50 translate-middle">
                    <Button
                        variant="outline-success"
                        onClick={handleMarkAsRead}
                        disabled={markingRead || logs.length === 0}
                        className="btn-sm btn-outline-success"
                    >
                        Mark All as Read
                    </Button>
                    <Button
                        variant="outline-success"
                        onClick={handleMarkAsReadAndClose}
                        disabled={markingRead || logs.length === 0}
                        className="btn-sm btn-outline-success ms-4"
                    >
                        Mark All as Read and Close
                    </Button>
                    <Button
                        variant="outline-secondary"
                        onClick={handleClose}
                        disabled={markingRead || logs.length === 0}
                        className="btn-sm ms-4"
                    >
                        Close Logs Window
                    </Button>
                </div>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center">
                        <Spinner animation="border" />
                    </div>
                ) : logs.length > 0 ? (
                    <Table bordered hover size="sm" striped className="mt-2">
                        <thead>
                        <tr className="bg-secondary text-center bg-opacity-50 text-sm">
                            <th className="small text-muted">Change:</th>
                            <th className="small text-muted">Balance:</th>
                            <th className="small text-muted">Description:</th>
                            <th className="small text-muted">Date:</th>
                            <th className="small text-muted">Status:</th>
                        </tr>
                        </thead>
                        <tbody>
                        {logs.slice(0, 50).map((log, index) => (
                            <tr key={log.id} className="small fst-italic">
                                <td className="text-center small text-success fw-bold" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {Number(log.amount) === 0
                                        ? 'No Changes'
                                        : `${log.amount > 0 ? '+' : ''}${Math.round(log.amount)} Virt`}
                                </td>
                                <td className="text-center small" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {log.balance_state > 0 ? `${Math.round(log.balance_state)}` : Math.round(log.balance_state)} Virt
                                </td>
                                <td className="small" style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "650px",  // Ограничиваем ширину
                                    width: "650px"      // Фиксируем ширину
                                }}>
                                    {log.description}
                                </td>

                                <td className="text-center small text-muted" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {new Date(log.user_log_date * 1000).toLocaleDateString('en-GB', {
                                        day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
                                    })}
                                </td>
                                <td className="text-center align-items-center small" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {!log.is_read ? <Badge bg="success">New</Badge> : <span className="text-muted">Read</span>}
                                </td>

                            </tr>
                        ))}
                        </tbody>
                    </Table>

                ) : (
                    <p className="text-center text-muted">No Logs</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={handleMarkAsReadAndClose}
                        className="btn-sm"
                        disabled={markingRead || logs.length === 0}>
                  Mark All as Read and Close
                </Button>
             </Modal.Footer>
        </Modal>
    );
};

export default UserLogsModal;
